const getters = {
  getPseStatus (store, getters) {
    return store.pseStatus
  },
  getPaymentLinkStatus(store, getters) {
    return store.paymentLinkStatus
  },
  getPseOrder (store, getters) {
    return store.pseOrder
  },
  getTemporalCoupon (store, getters) {
    return store.temporalCoupon
  }
}

export default getters
